import { showError } from 'utils/messages';
import PaymentMethodTypeSelectionView from 'app/views/payment_method_type_selection_view';
import BankAccountDetailsView from 'app/views/bank_account_details_view';
import CreditCardDetailsView from 'app/views/credit_card_details_view';
import Base from 'app/views/base';

import tmpl from 'templates/payment_method_details';

export default Base.extend({
  compiledTemplate: tmpl,

  initialize({ user }) {
    this.user = user;
    this.listenTo(this.model, 'change', this.render);
    this.model.fetch();
  },

  beforeRender() {
    this.removeSubviews();
    this.addSubview('primaryDetails', '#primary_payment_method', this.subviewInstanceForPriority(this.model.primary(), 'primary'));
    this.addSubview('secondaryDetails', '#secondary_payment_method', this.subviewInstanceForPriority(this.model.secondary(), 'secondary'));
  },

  afterRender() {
    this.$('[data-toggle="tooltip"]').tooltip({ html: true });
    if (!this.model.isNew() && !this.model.get('primary_payment_method')) {
      showError('Your account does not currently have a primary payment method on file.' +
      ' Please add a bank or credit card in order to ensure uninterrupted usage for any requests or api usage.', { noClose: 'noClose' });
    }
  },

  subviewInstanceForPriority(model, priority) {
    const priorityPaymentAttrs = {
      model,
      paymentMethods: this.model,
      priority,
      user: this.user,
    };

    if (model && model.get('object') === 'CreditCard') {
      return new CreditCardDetailsView(priorityPaymentAttrs);
    } else if (model && model.get('object') === 'BankAccount') {
      return new BankAccountDetailsView(priorityPaymentAttrs);
    }

    return new PaymentMethodTypeSelectionView({
      model: this.model,
      priority,
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/payment_method_details_view.js